<template>
  <modal
    name="week-review-form"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('week-review-form')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <div class="fl-msg" />

      <div
        v-if="date"
        class="ui-block-title"
      >
        <h6 class="title">
          Week Review Row
        </h6>
      </div>

      <div class="ui-block-content">
        <form
          class="content"
          @submit.prevent="submitRow"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Date</strong></p>
              <datepicker
                :value="date"
                class="form-group label-floating"
                @selected="dateSelected"
              />
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Category</strong></p>
              <select
                v-model="item.cat_id"
                class="form-group has-bootstrap-select "
              >
                <option :value="''">
                  Choose Category
                </option>
                <option
                  v-for="option in categories"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Title</strong></p>
              <input
                v-model="item.title"
                class="form-control label-floating"
              >
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Description</strong></p>
              <textarea
                v-model="item.description"
                rows="5"
                class="form-control label-floating"
              />
            </div>
          </div>

          <button
            class="btn btn-lg btn-breez full-width mt-4"
            type="submit"
            name="submit"
          >
            <span>{{ item.id ? 'Edit' : 'Add' }} Row</span>
          </button>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import VModal from 'vue-js-modal';
import Vue from 'vue'
Vue.use(VModal, {dialog: true});
import Datepicker from 'vuejs-datepicker'
import { mapState } from 'vuex'

const MODAL_HEIGHT = 800

import AppIcon from "../../common-apps/common/AppIcon"

export default {
  name: 'WeekReviewForm',
  components: { Datepicker, AppIcon },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      item: {
        cat_id: '',
        title: '',
        description: ''
      },
      date: new Date()
    }
  },
  computed: mapState({
    categories: state => state.weekReview.categories
  }),
  created () {
    this.modalHeight = window.innerHeight < MODAL_HEIGHT
      ? MODAL_HEIGHT - 200
      : MODAL_HEIGHT
  },
  methods: {
    dateSelected (date) {
      this.date = date
    },
    beforeOpen (event) {
      this.$store.dispatch('weekReview/getCat')
      if (event.params.item) {
        this.item = event.params.item
      }
    },
    // eslint-disable-next-line
    submitRow: function() { // !!!! this messes up if I use arrow function
      const payload = this.item
      payload.date = this.date
      if (this.item.id) {
        this.$store.dispatch('weekReview/edit', payload)
      } else {
        this.$store.dispatch('weekReview/add', payload)
      }
    }
  }
}
</script>


<style lang="scss">
  select.form-control {
    color: #000000;
    background-color: #ffffff;


  }

</style>


